<style>
	.red { color: #b67171; }
  .green { color: #71b672; }
  .purple { color: #9760af }
</style>

<script>
  export let stock = {};
  let color;
  let arrow;

  if (stock.change < 0) {
    color = 'red';
    arrow = '<i class="fa fa-long-arrow-down" aria-hidden="true"></i>';
  } else if (stock.change > 0) {
    color = 'green';
    arrow = '<i class="fa fa-long-arrow-up" aria-hidden="true"></i>';
  } else {
    color = '';
    arrow = '';
  }

</script>

<div class="ticker-box">
  <div class="ticker-row">
  { #if (stock.link) }
    <a href="{stock.link}" target="_blank">{stock.symbol}</a>
  {:else}
    <span class="purple">{stock.symbol}</span>
  {/if}
    <span class="pull-right {color}">{stock.change}</span>
  </div>
  <div class="ticker-row">
    <b>{stock.price}</b>
    <span class="pull-right {color}">
      { @html arrow }
      { stock.change_percent }%
    </span>
  </div>
</div>
